import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import * as moment from 'moment-timezone';
import {Moment} from 'moment-timezone';
import {limitDecimals} from 'src/app/shared/ec-economics';

export interface EnergyData {
    absorbedEnergy: number;
    effectiveInjectedEnergy: number;
    sharedEnergy: number;
}


@Component({
    selector: 'app-ec-energy-data',
    templateUrl: './ec-energy-data.component.html',
    styleUrls: ['./ec-energy-data.component.scss']
})
export class ECEnergyDataComponent implements OnInit, OnDestroy {

    private destroyed = new Subject<void>();

    @Input() date: Moment;
    @Output() values: EventEmitter<EnergyData> = new EventEmitter<EnergyData>();
    @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();

    month: string;
    year: number;
    form: FormGroup;

    readonly limitDecimals = limitDecimals;

    constructor(private fb: FormBuilder) {
        this.form = this.fb.group({
            absorbedEnergy: new FormControl(null, [Validators.required]),
            effectiveInjectedEnergy: new FormControl(null, [Validators.required]),
            sharedEnergy: new FormControl(null, [Validators.required])
        }, {
            validators: []
        });
    }

    ngOnInit() {
        /*
        this.form.controls.absorbedEnergy.setValue(isDefined(this.response.energy.accounted_absorbed_energy) ?
            Number(this.response.energy.accounted_absorbed_energy.toFixed(2)) : null);
        this.form.controls.effectiveInjectedEnergy.setValue(isDefined(this.response.energy.accounted_effective_injected_energy) ?
            Number(this.response.energy.accounted_effective_injected_energy.toFixed(2)) : null);
        this.form.controls.sharedEnergy.setValue(isDefined(this.response.energy.accounted_shared_energy) ?
            Number(this.response.energy.accounted_shared_energy.toFixed(2)) : null);
        */
        this.month = moment(this.date.month() + 1, 'MM').format('MMMM');
        this.year = this.date.year();
        this.form.valueChanges.pipe(
            takeUntil(this.destroyed)
        ).subscribe(value => {
            this.values.emit({
                absorbedEnergy: value.absorbedEnergy,
                effectiveInjectedEnergy: value.effectiveInjectedEnergy,
                sharedEnergy: value.sharedEnergy
            });
        });
        this.form.statusChanges.pipe(
            takeUntil(this.destroyed)
        ).subscribe(() => {
            this.valid.emit(this.form.valid);
        });
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
}


